import React, { createContext, useContext, useState, useEffect } from 'react';

const ChristmasThemeContext = createContext();

// Toggle this to enable/disable Christmas theme globally
const CHRISTMAS_THEME_ENABLED = false;

export const ChristmasThemeProvider = ({ children }) => {
  const [isChristmasTheme, setIsChristmasTheme] = useState(() => {
    // Only allow Christmas theme if globally enabled
    if (!CHRISTMAS_THEME_ENABLED) return false;
    
    try {
      const saved = localStorage.getItem('christmasTheme');
      // Default to true if not set (during holiday season)
      return saved !== null ? JSON.parse(saved) : true;
    } catch {
      return true;
    }
  });

  useEffect(() => {
    // Apply or remove the christmas class from the document
    if (isChristmasTheme && CHRISTMAS_THEME_ENABLED) {
      document.documentElement.classList.add('christmas-theme');
    } else {
      document.documentElement.classList.remove('christmas-theme');
    }
    
    // Save preference
    try {
      localStorage.setItem('christmasTheme', JSON.stringify(isChristmasTheme));
    } catch (error) {
      console.error('Error saving Christmas theme preference:', error);
    }
  }, [isChristmasTheme]);

  const toggleChristmasTheme = () => {
    if (CHRISTMAS_THEME_ENABLED) {
      setIsChristmasTheme(prev => !prev);
    }
  };

  return (
    <ChristmasThemeContext.Provider value={{ 
      isChristmasTheme: isChristmasTheme && CHRISTMAS_THEME_ENABLED, 
      toggleChristmasTheme,
      isChristmasEnabled: CHRISTMAS_THEME_ENABLED
    }}>
      {children}
    </ChristmasThemeContext.Provider>
  );
};

export const useChristmasTheme = () => {
  const context = useContext(ChristmasThemeContext);
  if (!context) {
    throw new Error('useChristmasTheme must be used within a ChristmasThemeProvider');
  }
  return context;
};

export default ChristmasThemeContext;

